import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Papa from "papaparse";
import DataTable from "react-data-table-component";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import {
  deleteUpcomingEvent,
  getUpcomingEventFiltersList,
  getUpcomingEventsList,
  getUpcomingEventsListCancelToken,
} from "../../../services/EventService";
import { handleTableScroll } from "../../../utils/commonFunction";
import {
  RenderWebsiteBrandTemplate,
  UpcomingEventsStatus
} from "../../../utils/CommonStatusItems";
import {
  TABLE_ROWS_PER_PAGE
} from "../../../utils/Constants";
import PermissionsGate from "../../../utils/permissionGate";
import Tablefilter from "../../common/Tablefilter";

function UpcomingEvents() {
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [status, setStatus] = useState({ arr: [], checkObj: {} });
  const [brand, setBrand] = useState({ arr: [], checkObj: {} });
  const [publishStatus, setPublishStatus] = useState({ arr: [], checkObj: {} });
  const [searchStatusCheck, setSearchStatusCheck] = useState({});
  const [deleterow, setDeleteRow] = useState(false);
  const [updateData, setUpdateData] = useState(true);
  const [eventsData, setEventsData] = useState([]);
  const [loading, setloading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [sortkey, setSortKey] = useState("");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [filterData, setFilterData] = useState({
    status: [],
    brand: [],
    publishStatus: []
  });

  useEffect(() => {
    handleTableScroll();
  }, [loading]);

  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $(".rdt_TableCell").css("z-index", 0);
        $(this).parents(".rdt_TableCell").css("z-index", 22);
      });
    });
  });
  useEffect(() => {
    const storedFilters = JSON.parse(
      localStorage.getItem("filterStateUpcomingEvents")
    );
    if (storedFilters) {
      setStatus(storedFilters?.status);
      setFilterData(storedFilters.filterData);
    }
  }, []);
  useEffect(() => {
    const filterState = {
      status,
      filterData,
    };
    localStorage.setItem(
      "filterStateUpcomingEvents",
      JSON.stringify(filterState)
    );
  }, [status,brand,publishStatus, filterData]);
  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $(".rdt_TableCell").css("z-index", 0);
        $(this).parents(".rdt_TableCell").css("z-index", 22);
      });
    });
  });
  useEffect(() => {
    const cancelTokenSources = [];
    const getUpcomingEventList = async () => {
      setloading(true);
      cancelTokenSources.forEach((source) => {
        source.cancel("New request made");
      });

      const source = axios.CancelToken.source();
      // setCancelTokenSources([...cancelTokenSources, source]);
      cancelTokenSources.push(source);

      const data = {
        page: page,
        perPage: perPage,
        keyval: sortkey,
        sort: sortOrder,
        search: search,
        exportStatus: false,
        viaStatus: status?.arr,
        viaBrand: brand?.arr,
        viaPublishStatus: publishStatus?.arr,
      };

      try {
        const res = await getUpcomingEventsListCancelToken(data, source.token);
        const event = res.data.data;
        setEventsData(event);
        setTotalRows(res.data?.total);
        setPerPage(res.data?.perPage);
        if (res.status == 200) {
          setloading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setloading(false);
        }
      }
    };

    getUpcomingEventList();

    return () => {
      cancelTokenSources.forEach((source) => {
        source.cancel("Component unmounted");
      });
    };
  }, [
    page,
    perPage,
    sortOrder,
    sortkey,
    search,
    status,
    brand,
    publishStatus,
    searchStatusCheck,
    updateData,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getUpcomingEventFiltersList();
        setFilterData({
          ...res.data,
          status: res.data?.eventItemStatusFilters
            ? res.data?.eventItemStatusFilters
            : [],
          brand: res.data?.eventTypesFilters ? res.data?.eventTypesFilters : [],
          publishStatus: res.data?.eventPublishStatus ? res.data?.eventPublishStatus : [],
        });
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    fetchData();
  }, []);

  usePermissionGuardRedirect(['wbseventupcomingview']);

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setDebouncedTerm(value);
  };

  const resetFilter = () => {
    setStatus({ arr: [], checkObj: {} });
    setBrand({ arr: [], checkObj: {} });
    setPublishStatus({ arr: [], checkObj: {} });
    setSearchStatusCheck({});
    setSearch("");
    setDebouncedTerm("");
  };

  const handlePageChange = (pageNo) => {
    setPage(pageNo);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  const handleSort = (column, sortDirection) => {
    setSortKey(column.sortField);
    setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteUpcomingEvent({ EventId: id })
          .then((res) => {
            Swal.fire(
              "Deleted!",
              "Upcoming Event has been deleted.",
              "success"
            );
            setUpdateData(!updateData);
          })
          .catch((error) => console.error(error));
      }
    });
  };

  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "EventTitle",
      sortField: "EventTitle",
      sortable: true,
      // minWidth: "190px",
      cell: (row) => (
        <PermissionsGate scopes={['wbseventupcomingedit']} RenderError={() => (<p>{row?.EventTitle}</p>)}>

        <Link
          className="as-text-blue curser feature-name"
          to={`/websiteManagement/events/upcoming_events/event_details/open/${row.EventId}`}
          title={row.EventTitle}
          >
          <span className="textLimit100">{row.EventTitle}</span>
        </Link>
        </PermissionsGate>
      ),
    },

    {
      name: "Status",
      selector: "status",
      sortField: "status",
      sortable: true,
      // maxWidth: "120px",
      // minWidth: "120px",
      cell: (row) => (row.status ? UpcomingEventsStatus(row.status).html : "-"),
    },
    {
      name: "Brand templates",
      selector: "brandTemplete",
      sortField: "brandTemplete",
      sortable: false,
      // maxWidth: "120px",
      // minWidth: "120px",
      cell: (row) => {
        if (row.brandTemplete.length) {
          const brandTemp = row.brandTemplete.map(
            (d, i) => RenderWebsiteBrandTemplate(d?.templateName).html
          );
          return brandTemp
        } else {
          return "-";
        }
      },
    },
    {
      name: "Event Date",
      selector: "EventDate",
      sortField: "EventDate",
      sortable: true,
      cell: (row) => {
        if (row && row.EventDate) {
          const eventDate = moment(row.EventDate).format("DD MMM YY");
          let endDate;
          if (row.EventEndDate && row.is_multiday_event) {
            endDate = moment(row.EventEndDate).format("DD MMM YY");
          }
          return eventDate + (endDate ? ` - ${endDate}` : "");
        }
        return '-';
      },
    },
    {
      name: "Event Time",
      selector: "siteDomain",
      sortField: "siteDomain",
      sortable: true,
      cell: (row) => (
        <>
          <div className="">
            <p className="right-space">{`${(row?.EventTime).replace(":00" , "")}-${(row?.EndEventTime).replace(":00" , "")}`}</p>
          </div>
        </>
      ),
    },
    {
      name: "Publish Status",
      selector: "IsPublished",
      sortField: "IsPublished",
      sortable: true,
      // maxWidth: "120px",
      // minWidth: "120px",
      cell: (row) => (row.IsPublished ? UpcomingEventsStatus(row.IsPublished).html : "-"),
    },
    {
      name: "Bookings",
      selector: "booking_count",
      sortField: "booking_count",
      sortable: true,
      cell: (row) => (row.booking_count ? row.booking_count : "-"),
    },
    {
      name: "Actions",
      selector: "",
      // maxWidth: "50px",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons d-flex">
            <PermissionsGate RenderError={() => (
              <button className="btn btn-primary h-auto rounded-circle" disabled>
                <i className="fal fa-folder-open"></i>
              </button>
            )} scopes={['wbseventupcomingedit']}>

            <Link
              className="btn btn-primary h-auto rounded-circle"
              to={`/websiteManagement/events/upcoming_events/event_details/open/${row.EventId}`}
              title="Open"
              >
              <i className="fal fa-folder-open"></i>
            </Link>
            </PermissionsGate>
            <PermissionsGate RenderError={() => (
              <button className="btn btn-danger rounded-circle" disabled>
                <i className="fal fa-trash-alt"></i>
              </button>
            )} scopes={['wbseventupcomingdelete']}>
            <button
              className="btn btn-danger rounded-circle"
              onClick={() => handleDelete(row.EventId)}
              >
              <i className="fal fa-trash-alt"></i>
            </button>
              </PermissionsGate>
          </div>
        </div>
      ),
    },
  ]);

  const exportData = (fileType, fileName) => {
    let data = [];
    const header = [
      "Name",
      "Status",
      "Brand Templates",
      "Event Date",
      "Event Time",
      "Publish Status",
      "Bookings",
    ];
    Swal.fire({
      title: "File downloading",
      didOpen: function () {
        Swal.showLoading();
      },
    });

    const eventsData = {
      page: page,
      perPage: perPage,
      keyval: sortkey,
      sort: sortOrder,
      search: search,
      exportStatus: true,
      viaStatus: status.arr,
      viaBrand: brand.arr,
      viaBrand: publishStatus.arr,
    };
 
    getUpcomingEventsList(eventsData)
      .then((res) => {
        data = res.data;
        data = data?.map((row) => ({
          ...row,
          Name: row?.EventTitle || "",
          Status: row.status ? UpcomingEventsStatus(row.status).text : "-",

          "Brand Templates":
          row?.brandTemplete?.map((d, i) => d?.templateName).join(",") ||
          "-",
          "Event Date": row?.EventDate
            ? moment(row?.EventDate)?.format("DD MMM YY")
            : "-",
          "Event Time": `${(row.EventTime).replace(":00","")}-${(row.EndEventTime).replace(":00","")}` || "-",
          Bookings: row.booking_count ? row.booking_count : "-",
          "Publish Status": row.IsPublished ? UpcomingEventsStatus(row.IsPublished).text : "-",
        }));

        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, data });
          const blob = new Blob([csvString], {
            type: "text/csv;charset=utf-8,",
          });

          const blobURL = window.URL.createObjectURL(blob);

          // Create new tag for download file
          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href,
          ].join(":");
          anchor.click();

          setTimeout(() => {
            URL.revokeObjectURL(blobURL);
          }, 1000);
          Swal.close();
        } else if (fileType === "xlsx") {
          const compatibleData = data.map((row) => {
            const obj = {};
            header.map((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
          Swal.close();
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = data.map((row) => {
            return [
              row?.EventTitle,
              UpcomingEventsStatus(row.status).text,
              row?.brandTemplete?.map((d, i) => d?.templateName).join(",") ||
                "-",
              row?.EventDate
                ? moment(row?.EventDate)?.format("DD MMM YY")
                : "-",
                `${(row.EventTime).replace(":00","")}-${(row.EndEventTime).replace(":00","")}`,
                row.IsPublished ? UpcomingEventsStatus(row.IsPublished).text : "-",
              row.booking_count,
            ];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              // valign: "center",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
          Swal.close();
          return false;
        }
      })
      .catch((err) => {
        Swal.close();
        
      });
  };

  useEffect(() => {
    const timer = setTimeout(() => setSearch(debouncedTerm), 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [debouncedTerm]);

  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
      <div className="custom-table-div filter-search-icon card card-table-custom program-table">
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div
                  id="assessment-table-main_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div
                    id="assessment-table-main_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      <input
                        type="search"
                        className=""
                        placeholder="Search"
                        aria-controls="assessment-table-main"
                        onChange={handleSearchFilter}
                        value={debouncedTerm}
                      />
                    </label>
                    <div className="filter-eff filter-data-btn">
                      <button className="filter-buttons">
                        <i className="fal fa-filter"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                <div className="filter-scroll">
                  <div className={`filter-scroll-inner filter-custom-new`}>
                    <Tablefilter
                      filterName="Status"
                      optionArr={filterData?.status}
                      state={status}
                      setState={setStatus}
                      renderLabelFunction={UpcomingEventsStatus}
                    />
                  </div>
                </div>
                <div className="filter-scroll">
                  <div className={`filter-scroll-inner filter-custom-new`}>
                    <Tablefilter
                      filterName="Brand Template"
                      optionArr={filterData?.brand}
                      state={brand}
                      setState={setBrand}
                      renderLabelFunction={RenderWebsiteBrandTemplate}
                      uniqueId="brand"
                    />
                  </div>
                </div>
                <div className="filter-scroll">
                  <div className={`filter-scroll-inner filter-custom-new`}>
                    <Tablefilter
                      filterName="Publish Status"
                      optionArr={filterData?.publishStatus}
                      state={publishStatus}
                      setState={setPublishStatus}
                      renderLabelFunction={UpcomingEventsStatus}
                    />
                  </div>
                </div>
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      onClick={resetFilter}
                      title="Reset"
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("xlsx", "Upcoming_event");
                      }}
                      title="Export spreadsheet"
                    >
                      <i className="fal fa-file-excel icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("csv", "Upcoming_event");
                      }}
                      title="Export CSV"
                    >
                      <i className="fal fa-file-csv icon"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("pdf", "Upcoming_event");
                      }}
                      title="Export PDF"
                    >
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="search-filter-div-right">
            <div className=" filter-search-bar-blk">
              <div className="add-ticket-blk button-reset dropdown-comman">
                <PermissionsGate scopes={['wbseventupcomingadd']} RenderError={() => (
                  <button className="btn btn-primary" disabled>
                    <i className="fal fa-plus"></i>Create New
                  </button>
                )}>

                <Link
                  to={`/websiteManagement/events/upcoming_events/event_details/create`}
                  >
                  <button
                    type="button"
                    className="btn btn-primary"
                    title="Create new"
                    >
                    <i className="fal fa-plus"></i>Create New
                  </button>
                </Link>
                </PermissionsGate>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          paginationDefaultPage={page}
          progressPending={loading}
          data={eventsData}
          progressComponent={<SkeletonTicketList />}
          defaultSortField={sortkey}
          defaultSortAsc={false}
          columns={columns}
          pagination={true}
          // noDataComponent={Str.noRecord}
          onSort={handleSort}
          sortServer
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          highlightOnHover={false}
          paginationPerPage={perPage}
          paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        />
      </div>
    </div>
  );
}

export default UpcomingEvents;
